import styled, { css } from 'styled-components';

export const DropdownArrowContainer = styled.div<{ isOpen: boolean }>`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%) rotate(${props => props.isOpen ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
  pointer-events: none;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInput = styled.input<{ hasError: boolean; isOpen: boolean; disabled?: boolean }>`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  width: 100%;
  padding-right: 40px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'text'};

  &:hover:not(:disabled) {
    border-color: #cbd5e0;
  }

  &:focus {
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }

  &:disabled {
    background-color: #f7fafc;
  }

  &::placeholder {
    color: #696969;
    font-style: italic;
  }

  ${props => props.hasError && `
    border: 1.5px solid #F87171;
    box-shadow: 0 0 3px #F87171;
  `}
`;

export const OptionsList = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: ${props => props.isOpen ? 'block' : 'none'};
  margin-top: 2px;
`;

export const OptionItem = styled.div<{ isHighlighted?: boolean; disabled?: boolean }>`
  padding: 12px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${props => !props.disabled ? '#f8f9fa' : 'white'};
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const OptionItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const OptionName = styled.span`
  font-weight: 500;
  color: #333;
`;

export const OptionDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
  font-size: 12px;
  color: #666;

  span {
    background-color: #f0f0f0;
    padding: 2px 6px;
    border-radius: 4px;
  }
`;

export const NoOptionsMessage = styled.div`
  padding: 12px;
  text-align: center;
  color: #666;
  font-style: italic;
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  padding: 12px;
  background: none;
  border: none;
  border-top: 1px solid #f0f0f0;
  cursor: pointer;
  color: #3182ce;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: #f8f9fa;
  }

  &:disabled {
    color: #999;
    cursor: not-allowed;
  }
`;

export const PriceTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
`;

export const PriceTag = styled.span`
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }
`; 